import WhatsAppCard from "@/components/parametres/integrations/WhatsAppCard";
import { FEATURE_FLAGS } from "@/lib/features";

const Integrations = () => {
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Connectez ScaniFood aux services que vous utilisez déjà.
      </p>
      {/* Hidden until the API supports per-restaurant WhatsApp (SFRESTO-154). */}
      {FEATURE_FLAGS.whatsappConnection && <WhatsAppCard />}
    </div>
  );
};

export default Integrations;
